import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import {
  AccountScreenBorderedSection,
  AccountScreenSection,
  AccountScreenSectionTitle,
} from '../../../Account';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardAccountSectionContainer = (props: Props) => {
  const { children, dataSet } = props;

  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  const accountScreenSectionStyles = match([
    styles.sectionContainerXS,
    undefined,
  ]);

  return (
    <View {...(dataSet ? { dataSet } : {})}>
      <AccountScreenSectionTitle title={t('account.gift-cards.title')} />
      <AccountScreenSection style={accountScreenSectionStyles}>
        <AccountScreenBorderedSection>{children}</AccountScreenBorderedSection>
      </AccountScreenSection>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  sectionContainerXS: {
    flexGrow: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Pick<ViewProps, 'children'> & { dataSet?: Record<string, string> };
